import angular from 'angular';
import template from './footer.tpl.html';
import './footer.scss';
import moment from "moment";
import 'moment-timezone';

class FooterController {

  constructor($rootScope, $window, $timeout, $ocLazyLoad, userService) {
    this.date = moment().format('YYYY');
    this.page = $rootScope.page;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$ocLazyLoad = $ocLazyLoad;
    this.$userService = userService;
    this.param = this.$userService.getQueryParamObject();
    this.redirect = false;
    this.form = '';
    this.redirectlink = '';
  }

  $onInit() {
    if (this.page) {
      this.checkRedirects();
      this.initBeacon();
    }
  }

  checkRedirects() {
    this.getRedirectMsg();
    if (this.page.options.redirect.enable && !this.$userService.hasProperty(this.param, 'redirect')) {
      var now = moment().utc().valueOf();
      var redi = moment.tz(this.page.options.redirect.datetime, 'America/New_York').utc().valueOf();
      this.redirectlink = this.getRedirectLink(this.param);
      if (now > redi) {
        if (this.$userService.getProperty(this.page.options.redirect, 'countdown') === false) {
          this.$window.location.href = this.redirectlink;
        } else {
          this.redirect = true;
          // var mytimeout = 0;
          this.initModal();
          this.$timeout(() => {
            this.onTimeout()
          }, 1000);
        }
      }
    }
  }

  onTimeout() {
    if (this.counter > 0) {
      this.counter--;
      this.$timeout(() => {
        this.onTimeout()
      }, 1000);
    } else if (this.counter == 0) {
      this.$window.location.href = this.redirectlink;
    }
  }

  getRedirectLink(param) {
    if (this.page.options.redirect.to.includes('AFFID=%%AFFID%%') && this.$userService.hasProperty(param, 'AFFID'))
      return this.page.options.redirect.to.replace('%%AFFID%%', param.AFFID);
    return this.page.options.redirect.to.replace("AFFID=%%AFFID%%", '').replace(/\?$/, '');
  }

  getRedirectMsg() {
    let parser = new DOMParser();
    const doc = parser.parseFromString(this.page.body, 'text/html');
    let elm = doc.getElementsByTagName('page-redirects');
    if (elm.length > 0) {
      this.counter = elm[0].getAttribute('delay') || 10;
      this.page.options.redirect.title = elm[0].getAttribute('title');
      this.page.options.redirect.desc = elm[0].getAttribute('desc');
      if (this.$userService.isAfter(elm[0].getAttribute('datetime')) && elm[0].getAttribute('form') && !this.$userService.hasProperty(this.param, 'redirect')) {
        this.form = elm[0].getAttribute('form');
        this.initModal();
        this.$timeout(() => {
          this.onTimeout()
        }, 1000);
      }
    } else {
      this.counter = 10;
      this.page.options.redirect.title = 'Sorry! This offer is no longer available.';
      this.page.options.redirect.desc = `Please visit us at <a href="${this.page.options.redirect.to}" class="link-primary" target="_self">${this.page.options.redirect.to}</a> to learn more about us.`;
    }
  }

  initBeacon() {
    if (this.page.options.beacon_id != '') {
      this.$ocLazyLoad.load('beacon').then(() => {
        this.$window.Beacon('init', this.page.options.beacon_id);
      });
    }
  }

  initModal() {
    import(
      /* webpackChunkName: "modal" */
      './../modal/modal'
    ).then(modalService => {
      this.ms = new modalService.default();
      this.ms.setModal('redirectmodal');
      this.ms.initModal();
    });
  }
}

FooterController.$inject = ["$rootScope", "$window", "$timeout", "$ocLazyLoad", "userService"];

class FooterComponent {
  constructor() {
    this.template = template;
    this.controller = FooterController;
  }
}


export default angular
  .module('mlrfooter.component', [])
  .component('mlrfooter', new FooterComponent())
  .name;
